import { HttpClient, setMap, toArray, uuidv4generate } from 'Mri.Web.Common';
import { action, observable, runInAction } from 'mobx';
import PartDefinitionBase = Mri.Parts.PartDefinitionBase;
import Fuse from 'fuse.js';
import { log } from 'util';

export interface ServiceKit {
    serviceKitKey?: string;
    serviceKitGuid?: string;
    name?: string;
    description?: string;
    assemblies?: ServiceKitAssembly[] | [];
    associatedDisplays?: [] | Record<string, any>;
}
export interface ServiceKitAssembly extends PartDefinitionBase {}

export class ServiceKitStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }
    @action
    public async loadAllServiceKits(): Promise<void> {
        this.serviceKitsLoading = true;
        const response = await this.httpClient.get<ServiceKit[]>('/api/v1/service-kits', {});
        setMap(this.serviceKits, response, m => m.serviceKitGuid);
        setMap(this.filteredServiceKits, response, m => m.serviceKitGuid);
        this.serviceKitsLoading = false;
    }

    @action
    public async loadServiceKit(serviceKitGuid: string) {
        const response = await this.httpClient.get<ServiceKit>(`/api/v1/service-kits/${serviceKitGuid}`);
        if (response) this.serviceKits.set(serviceKitGuid, response);
    }

    @action
    public async saveServiceKit(serviceKit: ServiceKit) {
        if (!serviceKit.serviceKitGuid) {
            await this.httpClient.put<ServiceKit>(`/api/v1/service-kits`, serviceKit);
        } else {
            await this.httpClient.post<ServiceKit>(`/api/v1/service-kits/${serviceKit.serviceKitGuid}`, serviceKit);
        }
        await this.loadAllServiceKits();
    }

    @action
    public async searchServiceKitsLocally(searchText: string) {
        if (!searchText || searchText === '') {
            setMap(this.filteredServiceKits, [...this.serviceKits.values()], m => m.serviceKitGuid);
            return;
        }
        const fuse = new Fuse(Array.from(this.serviceKits.values()), {
            keys: ['name', 'description'],
            threshold: 0.3,
        });
        setMap(this.filteredServiceKits, [...fuse.search(searchText).map(r => r.item)], m => m.serviceKitGuid);
    }

    @action
    public async deleteServiceKit(serviceKitGuid: string) {
        this.httpClient
            .delete(`/api/v1/service-kits/${serviceKitGuid}`)
            .then(() => {
                runInAction(() => {
                    this.serviceKits.delete(serviceKitGuid);
                    this.filteredServiceKits.delete(serviceKitGuid);
                });
            })
            .catch(error => console.error(error));
    }

    @action
    public async getAssociatedDisplays(serviceKitGuid: string) {
        this.httpClient
            .get(`/api/v1/display-associations/${serviceKitGuid}`)
            .then(response => {
                runInAction(() => {
                    const serviceKit = this.serviceKits.get(serviceKitGuid);
                    console.log(response);
                });
            })
            .catch(error => console.error(error));
    }

    @observable public serviceKits = new Map<string, ServiceKit>();
    @observable public filteredServiceKits = new Map<string, ServiceKit>();
    @observable public serviceKitsLoading = false;
    private readonly httpClient: HttpClient;
}
